import { useCallback } from 'react';

import { useCRMEventsContext } from 'state/crm-events';
import { useLocale } from 'state/intl';
import { changeUser, enableBrazeSdk, setEmail, wipeBrazeData } from 'utils/braze';
import { brand, env } from 'utils/environment';
import { login as ldLogin, logout as ldLogout } from 'utils/launchdarkly';

import { UserDetails } from './types';

export const useThirdPartyAuthentication = () => {
  const { region } = useLocale();
  const { loginCRM, logoutCRM } = useCRMEventsContext();

  const logUserInToThirdPartyServices = useCallback(
    (currentUser: UserDetails) => {
      ldLogin(currentUser);

      loginCRM({
        customerId: currentUser.cognitoId,
        rbiCognitoId: currentUser.cognitoId,
        ...currentUser.details,
        brand: brand().toUpperCase(),
        region,
        env: env() as string,
      });

      changeUser(currentUser.cognitoId);

      // Update Braze Email for the user
      setEmail(currentUser.details.email);
    },
    [loginCRM, region]
  );

  const logUserOutOfThirdPartyServices = useCallback(() => {
    ldLogout();
    logoutCRM();

    // The Braze documentation does not state this, but when calling Braze.wipeData()
    // The Braze SDK will be disabled permanently, at least on iOs.
    // Therefore, we need to call Braze.enableSDK()to re-enable the SDK.
    wipeBrazeData();
    enableBrazeSdk();
  }, [logoutCRM]);

  return { logUserInToThirdPartyServices, logUserOutOfThirdPartyServices };
};
